export default {"src":"/_next/static/media/CyanLocation.72021718.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};